document.addEventListener('DOMContentLoaded', () => {
  const formContent = document.querySelector('[data-role="contact-form-content"]');
  if (!formContent) return;

  let langPath = '';

  const formNotes = document.querySelectorAll<HTMLElement>('[data-role="form-ignore"]');

  // 入力フィールド初期化（省略可）
  const formInputItems = document.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
    '.form-item input, .form-item select, .form-item textarea'
  );

  formInputItems.forEach((input) => {
    const id = input.id;
    const name = input.name;

    if (input instanceof HTMLInputElement && input.type === 'radio') {
      input.addEventListener('change', () => {
        const checked = document.querySelector<HTMLInputElement>(`input[name="${name}"]:checked`);
        const confirmField = document.querySelector<HTMLElement>(`.confirm-${name}`);
        if (checked && confirmField) confirmField.textContent = checked.value;
      });

      const checked = document.querySelector<HTMLInputElement>(`input[name="${name}"]:checked`);
      const confirmField = document.querySelector<HTMLElement>(`.confirm-${name}`);
      if (checked && confirmField) confirmField.textContent = checked.value;
      return;
    }

    const confirmField = document.querySelector<HTMLElement>(`.confirm-${id}`);
    if (!confirmField) return;

    input.addEventListener('change', () => {
      confirmField.textContent = input.value;
    });
  });

  // 個人情報保護チェック
  const agreeCheckbox = document.querySelector<HTMLInputElement>('.acceptance-check');
  const confirmBtn = document.querySelector<HTMLButtonElement>('[data-role="confirm-btn"]');

  if (agreeCheckbox && confirmBtn) {
    agreeCheckbox.addEventListener('click', () => {
      confirmBtn.disabled = !agreeCheckbox.checked;
    });
  }

  // 確認ボタン
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      const formInput = document.querySelector<HTMLElement>('.form-input');
      const formConfirm = document.querySelector<HTMLElement>('.form-confirm');
      const primary = document.querySelector<HTMLElement>('#primary');

      if (formInput && formConfirm) {
        formInput.style.display = 'none';
        formConfirm.style.display = 'block';
      }

      formNotes.forEach((note) => (note.style.display = 'none'));

      if (primary) {
        window.scrollTo({
          top: primary.getBoundingClientRect().top,
          behavior: 'smooth',
        });
      }
    });
  }

  // 戻るボタン
  const backBtn = document.querySelector<HTMLButtonElement>('[data-role="back-btn"]');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      const formInput = document.querySelector<HTMLElement>('.form-input');
      const formConfirm = document.querySelector<HTMLElement>('.form-confirm');
      const primary = document.querySelector<HTMLElement>('#primary');

      if (formInput && formConfirm) {
        formInput.style.display = 'block';
        formConfirm.style.display = 'none';
      }

      formNotes.forEach((note) => (note.style.display = 'block'));

      if (primary) {
        window.scrollTo({
          top: primary.getBoundingClientRect().top,
          behavior: 'smooth',
        });
      }
    });
  }

  // --- CF7送信完了時 ---
  const photoDownloadFormIds = [1838]; // ダウンロード対象フォームID

  document.addEventListener('wpcf7mailsent', (event: Event) => {
    const wpcf7Event = event as CustomEvent;
    const formId = wpcf7Event.detail.contactFormId;

    const path = location.pathname.endsWith('/') ? location.pathname : location.pathname + '/';
    const lang = document.documentElement.lang;
    let prefix = '';
    switch (lang) {
      case 'en': prefix = '/en'; break;
      case 'zh-hans': prefix = '/zh-hans'; break;
      case 'zh-hant': prefix = '/zh-hant'; break;
      case 'ko-KR': prefix = '/ko'; break;
      case 'th': prefix = '/th'; break;
      default: prefix = '';
    }

    if (photoDownloadFormIds.includes(formId)) {

      // hidden input から選択画像取得
      const hidden = document.querySelector<HTMLInputElement>('input[name="selected_post_ids"]');
      const imageIds = hidden?.value ? hidden.value.split(',').map(id => parseInt(id)) : [];

      if (!imageIds.length) {
        alert('ダウンロードする画像が選択されていません');
        return;
      }

      // Ajax で ZIP生成 + セッション保存
      fetch(window.photoZip.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          action: 'photo_zip_create',
          nonce: window.photoZip.nonce,
          image_ids: JSON.stringify(imageIds),
        }),
      })
        .then(res => res.json())
        .then((data) => {
          if (data.success) {
            // localStorage削除
            ['selectedImages', 'selectedVideos'].forEach(k => localStorage.removeItem(k));
            // チェックボックスクリア
            document.querySelectorAll<HTMLInputElement>('.photo-checkbox, .video-checkbox')
              .forEach(cb => cb.checked = false);
            // hidden input も削除
            const hiddenFieldsContainer = document.getElementById('hidden-fields');
            if (hiddenFieldsContainer) hiddenFieldsContainer.innerHTML = '';

            // ダウンロードページへ token付きで遷移
            location.href = data.data.download_url;
          } else {
            alert(data.data?.message || 'ZIP生成に失敗しました');
          }
        })
        .catch(() => alert('通信エラーによりZIP生成に失敗しました'));
    } else {
      // 通常フォームはサンクスページへ
      location.href = `${prefix}${path}thanks/`;
    }
  }, false);

});
